import React from "react";
// Correct imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi';
import "./Ministries.css";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";

export const steps = [
  {
    title: "Youth",
    desc: "There’s a seat for you at Anchor. You're invited to join us on an upcoming Sunday. Join us for a time of worship, teaching, and fellowship.",
    img: "https://images.unsplash.com/photo-1563902341721-029085ad9347?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y2h1cmNoJTIweW91dGh8ZW58MHx8MHx8fDA%3D",
  },
  {
    title: "Young Adults",
    desc: "Open and growing groups develop lasting relationships, talk about who God is, and what it looks like to follow Him.",
    img: "https://plus.unsplash.com/premium_photo-1723874547905-d5b21d02b296?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8eW91bmclMjBhZHVsdHN8ZW58MHx8MHx8fDA%3D",
  },
  {
    title: "KIDS",
    desc: "A safe and loving environment for kids to experience the hope of the Gospel while having a lot of fun.",
    img: "https://images.unsplash.com/photo-1698795635824-241edc32eccd?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGNodXJjaCUyMGtpZHN8ZW58MHx8MHx8fDA%3D",
  },
  {
    title: "Women",
    desc: "A safe and loving environment for kids to experience the hope of the Gospel while having a lot of fun.",
    img: "https://img.freepik.com/free-photo/girls-sitting-around-table-reading-book-with-blurred-background_181624-5547.jpg?semt=ais_hybrid&w=740",
  },
];

const Ministries = () => {
  return (
    <div className="section ministries" id="ministries">
      <div className="container is-fluid">
        <div className="is-flex is-justify-content-space-between is-align-items-center mb-5 is-desktop-center">
          <h2 className="main-title title is-3 has-text-centered custom-flex-end">Apostolic Ministries</h2>
          {/* Custom Navigation Buttons */}
          <div className="swiper-navigation is-flex is-desktop-center-flex-end">
            <button className="custom-prev">
              <HiArrowLeft size={18} color="black"/>
            </button>
            
            <button className="custom-next" >
              {" "}
              <HiArrowRight size={18} color="black"/>
            </button>
      
          </div>
        </div>

        <Swiper
          modules={[Navigation, Pagination]}
          slidesPerView={1}
          spaceBetween={20}
          navigation={{
            nextEl: ".custom-next",
            prevEl: ".custom-prev",
          }}
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {steps.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className="card is-shadowless"
                style={{ borderRadius: "1rem", overflow: "hidden" }}
              >
                <div className="card-image">
                  <figure className="image is-4by3">
                    <img src={item.img} alt={item.title} />
                  </figure>
                </div>
                <div className="card-content">
                  <p className="title sub-title is-5 has-text-weight-bold">
                    {item.title}
                  </p>
                  <p className="subtitle  sub-title is-6">{item.desc}</p>
                  <a
                    className="has-text-weight-bold is-underlined"
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn More <HiArrowRight className="arrow-icon" size={18} />
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Ministries;
